import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { InputValidationErrorsComponent } from './input-validation-errors.component';


@NgModule({
  declarations: [
    InputValidationErrorsComponent
  ],
  exports: [
    InputValidationErrorsComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class InputValidationErrorsModule { }
